import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/Rubik/Rubik-Regular.ttf';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);